export default __webpack_public_path__ + "static/media/education_logo.909d91cc.jfif";